'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  position: relative;\n  overflow: hidden;\n  border-radius: ', ';\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.0625);\n'], ['\n  position: relative;\n  overflow: hidden;\n  border-radius: ', ';\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.0625);\n']);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Card = require('./Card');

var _Card2 = _interopRequireDefault(_Card);

var _Container = require('./Container');

var _Container2 = _interopRequireDefault(_Container);

var _theme = require('./theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Sheet = (0, _styledComponents2.default)(_Card2.default.withComponent(_Container2.default))(_templateObject, _theme2.default.radii[2]);

Sheet.displayName = 'Sheet';

Sheet.defaultProps = {
  theme: _theme2.default,
  bg: 'rgba(255, 255, 255, 0.875)',
  p: [3, 4]
};

exports.default = Sheet;